import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";

const links = [
    { to: "/", label: "Accueil", end: true },
    { to: "/a-propos", label: "À propos" },
    { to: "/accompagnements", label: "Nos accompagnements" },
    { to: "/contact", label: "Contact" },
];

export default function PublicNav() {
    const [open, setOpen] = useState(false);
    const { user } = useAuth();
    const isAuthed = user && typeof user === "object";
    const authHref = isAuthed ? (user.role === "client" ? "/espace-client" : "/dashboard") : "/login";
    const authLabel = isAuthed ? "Mon espace" : "Connexion";
    const authTestId = isAuthed ? "nav-mon-espace" : "nav-se-connecter";
    return (
        <header
            data-testid="public-nav"
            className="sticky top-0 z-40 bg-ink-800/85 backdrop-blur-md border-b border-ice/10"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
                <Link to="/" data-testid="logo-link" className="flex items-center">
                    <Logo variant="header" className="h-4 w-auto" />
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={`nav-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                            className={({ isActive }) =>
                                `text-base tracking-wide transition-colors ${
                                    isActive ? "text-ice" : "text-white/85 hover:text-ice"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <Link
                        to={authHref}
                        data-testid={authTestId}
                        className="text-base tracking-wide text-white/85 hover:text-ice transition-colors border-l border-white/10 pl-8"
                    >
                        {authLabel}
                    </Link>
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    aria-label="Menu"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-white p-2"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-ink-800">
                    <div className="px-6 py-4 flex flex-col gap-3">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.end}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `text-sm py-2 ${isActive ? "text-ice" : "text-white/80"}`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link to={authHref} onClick={() => setOpen(false)} data-testid={`${authTestId}-mobile`} className="text-sm py-2 text-white/80">
                            {authLabel}
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
